import { render } from "./Home.vue?vue&type=template&id=55b3806e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=55b3806e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/company-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b3806e"]])

export default __exports__